import { TFunction } from 'i18next';
import * as Yup from 'yup';
export const validationSchema = (t: TFunction) =>
  Yup.object({
    cost_price: Yup.string()
      .typeError(t('valid_err_number'))
      .required(t('valid_err_price')),
    unit_price: Yup.string()
      .typeError(t('valid_err_number'))
      .required(t('valid_err_price')),
    unit_price1: Yup.string().nullable(),
    unit_price2: Yup.string().nullable(),
    unit_price3: Yup.string().nullable(),
    unit_price4: Yup.string().nullable(),
  });
export type PricesValidationSchemaType = ReturnType<typeof validationSchema>;
